import { render, staticRenderFns } from "./settingContentParams.vue?vue&type=template&id=b4c5375c&scoped=true"
import script from "./settingContentParams.vue?vue&type=script&lang=js"
export * from "./settingContentParams.vue?vue&type=script&lang=js"
import style0 from "./settingContentParams.vue?vue&type=style&index=0&id=b4c5375c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c5375c",
  null
  
)

export default component.exports